import { render, staticRenderFns } from "./Warranty.vue?vue&type=template&id=4ba41168"
import script from "./Warranty.vue?vue&type=script&setup=true&lang=js"
export * from "./Warranty.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports